import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { getAppRoutesArray } from './app-routes';
import { where } from '../framework/utils/collection';
import { ResourceNotFoundPage } from '../pages/not-found';
import { usePageManager } from './services/page-manager';
export { AttHubAppType } from './app-type';

export const AppPages: React.FunctionComponent = () => {
  usePageManager();
  const topLevelRoutes = where(getAppRoutesArray(), route => route.topLevel);
  return (
    <Switch>
        {topLevelRoutes.map(route => <Route key={route.key} path={route.urlTemplate} exact={route.exact} component={route.component} />)}
        <Route path={'*'} component={ResourceNotFoundPage} />
    </Switch>
  );
};
